import React from 'react';
import '../../tailwind.css';
import '../../assets/styles/styles.css';

export const ThemeWrapper = ({ children }) => (
  <React.Fragment>{children}</React.Fragment>
);

export default ThemeWrapper;
